import React, { useEffect, useState } from 'react';
import Breadcrumb from '../../../components/BreadCrumb/breadCrumb';
import Strings from '../../../constants/stringConstant';
import Path from '../../../constants/path';
import sharedStyles from '../Masters.module.css';
import { Box, Grid, IconButton } from '@mui/material';
import SearchBox from '../../../components/SearchBox/searchBox';
import ButtonComp from '../../../components/Button/buttonComp';
import { ReactComponent as AddIcon } from '../../../assets/images/addIconWhite.svg';
import PaginationComp from '../../../components/Pagination/paginationComp';
import ModalwithButton from '../../../components/Modal/modalwithButton';
import AddEditDairyMaster from './AddEditDairyMaster';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import makeApiCall from '../../../api/makeApiCall';
import SuccessModal from '../../../components/Modal/successModal';
import PartialUploadModal from '../StateMasters/partialUploadModal';
import { ReactComponent as EditSharpIcon } from '../../../assets/images/editIcon.svg';
import TableComp from '../../LoanApplicationsPage/LoanApplicationsDashboard/OtherLoanApplicationStages/componenets/StaticPages/EligibilityCheck/CamTab/TableComp';
import { useSelector } from 'react-redux';
import { addUpdateDairyMaster, fetchDairyMaster } from '../../../api/request/masterFetchApi/masterFetchApi';

function DairyMaster() {
    const { t: translator } = useTranslation();
    const paths = [
        {
            name: Strings.masters.masters,
            link: Path.dairy_master,
        },
        { name: Strings.masters.dairy_master, link: '' },
    ];
    const [searchQuery, setSearchQuery] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [addEditDairyModal, setAddEditDairyModal] = useState(false);
    const [type, setType] = useState('add');
    const [selectedRowObject, setSelectedRowObject] = useState({});
    const [totalPages, setTotalPages] = useState(0);
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(false);
    const [successModal, setSuccessModal] = useState(false);
    const [noRecordsFound, setNoRecordsFound] = useState(false);
    const [failedModal, setFailedModal] = useState(false);
    const [uploadSuccessModal, setUploadSuccessModal] = useState(false);
    const [uploadFailedModal, setUploadFailedModal] = useState(false);
    const [failedRecords] = useState([]);
    const [totalRecordCount] = useState('');
    const [partialUpload, setPartialUpload] = useState(false);
    const [isModalVisible, setModalVisible] = useState(false);
    const { roleBased } = useSelector(state => state.rbacValue);
    console.log(roleBased);
    const isEditDairy = roleBased?.masters?.sections?.dairy_master !== 'edit';
    const rowPerTable = 10;

    function toggleAddEditDairyModal() {
        setAddEditDairyModal(!addEditDairyModal);
    }

    useEffect(() => {
        fetchDairyMasterApi();
    }, [searchQuery, currentPage]);

    useEffect(() => {
        if (successModal) {
            setTimeout(() => {
                handleSuccessModal();
            }, 2000);
        }
    }, [successModal]);

    useEffect(() => {
        if (failedModal) {
            setTimeout(() => {
                handleFailedModal();
            }, 2000);
        }
    }, [failedModal]);

    useEffect(() => {
        if (uploadSuccessModal) {
            setTimeout(() => {
                setUploadSuccessModal(false);
            }, 2000);
        }
    }, [uploadSuccessModal]);

    useEffect(() => {
        if (uploadFailedModal) {
            setTimeout(() => {
                setUploadFailedModal(false);
            }, 2000);
        }
    }, [uploadFailedModal]);

    const handleApiError = response => {
        let errorCode = response?.data?.error?.errorCode;
        let errorMessage = translator(`ErrorMessages.${errorCode}`);
        if (errorCode === 'SAMASTA013') {
            setNoRecordsFound(true);
            return;
        }
        if (errorCode === 'SAMASTA088') {
            toast.error(response?.data?.error?.errorMessage, { position: 'top-right' });
            return;
        }
        if (!errorCode || errorMessage === `ErrorMessages.${errorCode}`) {
            errorCode = 'SAMASTA001';
            errorMessage = translator('ErrorMessages.SAMASTA001');
        }
        if (errorCode !== 'SAMASTA015') {
            toast.error(errorMessage, { position: 'top-right' });
        }
    };

    const fetchDairyMasterApi = async () => {
        setLoading(true);
        try {
            const requestPayload = {
                pageNumber: currentPage - 1,
                pageSize: rowPerTable,
                searchTerm: searchQuery,
            };
            const response = await makeApiCall(fetchDairyMaster(requestPayload));
            if (response?.data?.status === Strings?.success) {
                const data = response?.data?.data?.content ?? [];
                setRows(data);
                setTotalPages(
                    Math.ceil(response?.data?.data?.totalElements / rowPerTable),
                );
                if (data?.length === 0) {
                    setNoRecordsFound(true);
                } else {
                    setNoRecordsFound(false);
                }
            } else {
                handleApiError(response);
            }
        } catch (error) {
            toast.error(Strings.apiError, { position: 'top-right' });
        } finally {
            setLoading(false);
        }
    };

    const addUpdateDairyMasterApi = async (data) => {
        setLoading(true);
        console.log(data, 'dataa');
        try {
            const requestPayload = {
                id: data?.id || null,
                cattleType: data?.cattleType ?? '',
                cattleSubType: data?.cattleSubType ?? '',
                income: Number(data?.income),
                status: data?.status,
            };
            const response = await makeApiCall(addUpdateDairyMaster(requestPayload));
            if (response?.data?.status === Strings?.success) {
                setSuccessModal(true);
                fetchDairyMasterApi(currentPage, searchQuery);
            } else {
                handleApiError(response);
                setFailedModal(true);
                setSuccessModal(false);
            }
        } catch (error) {
            toast.error(Strings.apiError, { position: 'top-right' });
        } finally {
            setLoading(false);
        }
    };

    const loanColumns = [
        { label: 'Cattle Type', field: 'cattleType' },
        { label: 'Cattle Subtype', field: 'cattleSubType' },
        { label: 'Income', field: 'income' },
    ];

    const handleSearch = query => {
        setSearchQuery(query);
        setCurrentPage(1);
    };

    const handlePageChange = (event, value) => {
        setCurrentPage(value);
    };

    const handleSuccessModal = () => {
        setSuccessModal(false);
    };

    const handleFailedModal = () => {
        setFailedModal(false);
    };

    const handleStatusChange = selectedRow => {
        setSelectedRowObject(selectedRow);
        setModalVisible(true);
    };

    const handleStatusCancel = () => {
        setModalVisible(false);
        setSelectedRowObject({});
    };

    const handleConfirm = async () => {
        setLoading(true);
        try {
            const updatedStatus = !selectedRowObject.status;
            const requestPayload = {
                ...selectedRowObject,
                status: updatedStatus,
            };
            const response = await makeApiCall(addUpdateDairyMaster(requestPayload));
            if (response?.data?.status === Strings.success) {
                fetchDairyMasterApi(currentPage, searchQuery);
                setModalVisible(false);
                setSelectedRowObject({});
            } else {
                handleApiError(response);
            }
        } catch (error) {
            console.error('API Error:', error);
        } finally {
            setLoading(false);
        }
    };
    return (
        <Box className={sharedStyles.main_container}>
            <Breadcrumb paths={paths} />
            <Box className={sharedStyles.secondary_container}>
                <Grid
                    container
                    sx={{
                        gap: '12px',
                        justifyContent: 'space-between',
                    }}>
                    <Grid item>
                        <SearchBox searchQuery={searchQuery} onSearch={handleSearch} />
                    </Grid>
                    <Grid item>
                        <Grid
                            container
                            sx={{
                                gap: '12px',
                            }}>
                            <ButtonComp
                                type="submit"
                                className="text-bold-16px"
                                endIcon={<AddIcon />}
                                value={Strings.masters.add_new}
                                gradient="linear-gradient(168deg, #F37021 -13.5%, #FDBA12 119.9%)"
                                height="40px"
                                padding="14px 24px"
                                textcolor="#fff"
                                borderRadius="8px"
                                onClick={() => {
                                    setType('add');
                                    toggleAddEditDairyModal();
                                }}
                                disabled={isEditDairy}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <TableComp
                    loader={loading}
                    columns={loanColumns}
                    rows={rows}
                    editDisabled={isEditDairy}
                    handleActionClick={row => {
                        setType('edit');
                        toggleAddEditDairyModal();
                        setSelectedRowObject(row);
                        fetchDairyMasterApi();
                    }}
                    showTotal={false}
                    firstColumnBgColor={'white'}
                    statusColumn={true}
                    statusChange={handleStatusChange}
                    noRecordsFound={noRecordsFound}
                    actionIcon={
                        <IconButton aria-label="close" disabled={isEditDairy}>
                            <EditSharpIcon />
                        </IconButton>
                    }
                />
                {totalPages > 0 && !noRecordsFound && (
                    <PaginationComp
                        totalPages={totalPages}
                        currentPage={currentPage}
                        handlePageChange={handlePageChange}
                    />
                )}
            </Box>
            {addEditDairyModal && (
                <ModalwithButton
                    open={addEditDairyModal}
                    message={type === 'add' ? 'Add Dairy Details' : 'Edit Dairy Details'}
                    subMessage={
                        'Fill in the below details to add them to the master table'
                    }
                    leftRenderWithoutPadding
                    bolderHeadings
                    subMessageColor={'#475467'}
                    onClose={toggleAddEditDairyModal}
                    minWidth={'50%'}>
                    <AddEditDairyMaster
                        closeModal={toggleAddEditDairyModal}
                        selectedRowObject={selectedRowObject}
                        type={type}
                        addUpdateDairyMasterApi={addUpdateDairyMasterApi}
                    />
                </ModalwithButton>
            )}
            <SuccessModal
                open={successModal}
                onClose={handleSuccessModal}
                message={
                    type === 'add'
                        ? Strings.masters.added_record
                        : Strings.masters.updated_record
                }
                subMessage={
                    type === 'add'
                        ? Strings.masters.added_record_des
                        : Strings.masters.updated_record_des
                }
            />
            <SuccessModal
                open={failedModal}
                onClose={handleFailedModal}
                message={
                    type === 'add'
                        ? Strings.masters.failed_added_record
                        : Strings.masters.failed_updated_record
                }
                subMessage={
                    type === 'add'
                        ? Strings.masters.failed_added_record_des
                        : Strings.masters.failed_updated_record_des
                }
                reject
            />
            <SuccessModal
                open={uploadSuccessModal}
                onClose={() => setUploadSuccessModal(false)}
                message={Strings.masters.bulk_upload_success}
                subMessage={`All ${totalRecordCount} records have been successfully uploaded.`}
            />
            <SuccessModal
                open={uploadFailedModal}
                onClose={() => setUploadFailedModal(false)}
                message={Strings.masters.bulk_upload_failed}
                subMessage={Strings.masters.bulk_upload_failed_des}
                reject
            />
            {partialUpload && (
                <PartialUploadModal
                    isOpen={partialUpload}
                    onClose={() => setPartialUpload(false)}
                    failedRecords={failedRecords}
                    totalRecordCount={totalRecordCount}
                />
            )}
            <ModalwithButton
                open={isModalVisible}
                message={Strings.masters.status_change}
                subMessage={Strings.masters.status_change_msg}
                value={'Yes'}
                onClickButton={handleConfirm}
                onClose={handleStatusCancel}
                cancelBtn
            />
        </Box>
    );
}

export default DairyMaster;
